import type { Validator } from 'last-validator'
import { test } from 'last-validator'
import { useSlug } from '@/composables/slug/useSlug'

export const isAvailableSlug = (collection: any, excludeId?: string): Validator =>
    test(async (value) => {
        const { validateSlug } = useSlug()
        return await validateSlug(collection, value, excludeId)
    }, 'Tento slug je už obsadený, zvoľte prosím iný.')
